import { Backdrop, Box } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/EditOutlined";
import { useMutateForm } from "api/useMutateForm";
import { useSimpleModalToggle } from "components/dialogs/useSimpleModal";
import React from "react";
import { FormWithRedirect, useRefresh, useTranslate } from "react-admin";

export const EditEntityDialogButton = ({
	resource,
	record,
	mutationType = "updatePartial",
	titleKey,
	successMessageKey,
	maxWidth = "sm",
	fullWidth = true,
	disabled = false,
	prepareValues,
	onSaved,
	trigger,
	children,
}) => {
	const { open, handleOpen, handleClose } = useSimpleModalToggle();
	const refresh = useRefresh();
	const translate = useTranslate();

	const [submit, { loading }] = useMutateForm(
		mutationType,
		resource,
		null,
		record.id,
		{},
		() => {
			handleClose();
			refresh();
			onSaved && onSaved();
			return true;
		},
		undefined,
		successMessageKey ? translate(successMessageKey) : undefined
	);

	const handleSave = (values) => {
		const data = prepareValues ? prepareValues(values) : values;
		if (!data || Object.keys(data).length === 0) {
			handleClose();
			return;
		}
		return submit(data);
	};

	return (
		<>
			{trigger ? (
				trigger({ open: handleOpen, disabled })
			) : (
				<IconButton
					aria-label="edit"
					size="small"
					onClick={(e) => {
						e.stopPropagation();
						handleOpen();
					}}
					disabled={disabled}
				>
					<EditIcon color={disabled ? "disabled" : "primary"} fontSize="small" />
				</IconButton>
			)}

			{open && (
				<Dialog
					open
					onClose={handleClose}
					maxWidth={maxWidth}
					fullWidth={fullWidth}
					onClick={(e) => e.stopPropagation()}
				>
					<DialogTitle>{translate(titleKey)}</DialogTitle>

					<Box position="relative">
						<FormWithRedirect
							record={record}
							submitOnEnter={false}
							save={handleSave}
							render={({ handleSubmitWithRedirect, form, record: formRecord }) => (
								<>
									<DialogContent>{children({ record: formRecord, form })}</DialogContent>

									<DialogActions>
										<Button onClick={handleClose} disabled={loading}>
											{translate("ra.action.cancel")}
										</Button>
										<Button
											onClick={handleSubmitWithRedirect}
											color="primary"
											disabled={loading}
										>
											{translate("ra.action.update")}
										</Button>
									</DialogActions>
								</>
							)}
						/>

						<Backdrop
							open={loading}
							style={{
								position: "absolute",
								zIndex: 1000,
								backgroundColor: "rgba(255, 255, 255, 0.7)",
							}}
						>
							<CircularProgress />
						</Backdrop>
					</Box>
				</Dialog>
			)}
		</>
	);
};
